import { APP_ROUTER_BASENAME } from "admin-portal/src/app/app-routes";
import { useAppRootRoute } from "utils/hooks/use-app-route-root";
export const useAdminPortalRootRoute = () => {
  return useAppRootRoute(APP_ROUTER_BASENAME, 3001);
};
